import React from "react";
import { Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Login from "./pages/Login";
import Layout from "./layout/Layout";
import Dashboard from "./pages/Dashboard";
import TankerEntryForm from "./components/TankerEntryForm";
import TankerEntryTable from "./components/TankerEntryTable";
import QrScanner from "./pages/QrScanner";
import LabReport from "./components/LabReport";
import { ToastContainer } from "react-toastify";
import LabAndGateEntryReport from "./components/LabAndGateEntryReport";

const App = () => {
  return (
    <>
      {/* ❗ NO BrowserRouter here */}
      <Routes>
        {/* Public pages */}
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />

        {/* After Login */}
        <Route path="/app" element={<Layout />}>
          <Route index element={<Dashboard />} />
          <Route path="test-report" element={<LabAndGateEntryReport />} />
          <Route path="gate-entry" element={<TankerEntryTable />} />
          <Route path="gate-entryF/:EditFlag/:tId" element={<TankerEntryForm />} />
          <Route path="qr-scanner" element={<QrScanner />} />
          <Route path="lab-report" element={<LabReport />} />
        </Route>
      </Routes>

      <ToastContainer position="top-right" theme="colored" />
    </>
  );
};

export default App;
